var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerChromeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 35C42.2 35 43.98 32.75 43.98 30L44 5C44 2.25 42.2 0 40 0H8C5.8 0 4 2.25 4 5V30C4 32.75 5.8 35 8 35H0V40H48V35H40ZM8 5H40V30H8V5Z",
    fill: "#495058"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_219_916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.375 18C14.3711 16.3086 14.8198 14.647 15.6744 13.1875L19.7994 20.3925V20.4338C20.228 21.1651 20.8423 21.7702 21.5799 22.1879C22.3175 22.6056 23.1524 22.8211 24 22.8125C24.439 22.809 24.8758 22.7489 25.2994 22.6337L22.5082 27.4462C20.2523 27.0924 18.1957 25.948 16.7059 24.2176C15.216 22.4871 14.3898 20.2834 14.375 18Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 27.625L28.1662 20.4062C28.6996 19.481 28.91 18.4047 28.7644 17.3467C28.6187 16.2887 28.1253 15.3092 27.3619 14.5625H32.9788C33.5357 16.0191 33.7304 17.5893 33.546 19.1379C33.3617 20.6864 32.8038 22.167 31.9204 23.4521C31.037 24.7373 29.8546 25.7886 28.4749 26.5155C27.0952 27.2424 25.5595 27.6231 24 27.625Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 21.4375C25.8985 21.4375 27.4375 19.8985 27.4375 18C27.4375 16.1015 25.8985 14.5625 24 14.5625C22.1015 14.5625 20.5625 16.1015 20.5625 18C20.5625 19.8985 22.1015 21.4375 24 21.4375Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0986 13.0337L23.7638 13.035C22.6959 13.0357 21.6585 13.3917 20.8151 14.0468C19.9717 14.7019 19.3702 15.6189 19.1052 16.6535L16.2968 11.7891C17.2798 10.5785 18.5422 9.62478 19.9755 9.01016C21.4088 8.39554 22.9699 8.13839 24.5246 8.26084C26.0793 8.38329 27.5809 8.88167 28.9003 9.71309C30.2196 10.5445 31.3172 11.6841 32.0986 13.0337Z",
    fill: "#F44336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_219_916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(13 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerChromeIcon);
export default __webpack_public_path__ + "static/media/computer_chrome_icon.c6735e86.svg";
export { ForwardRef as ReactComponent };